var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tiptap-vuetify',{attrs:{"card-props":{ flat: true },"value":_vm.value,"extensions":_vm.extensions,"placeholder":"Start typing here..."},on:{"input":function($event){return _vm.$emit('fieldChange', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }